import React from "react";
import { useTranslation } from "react-i18next";
import SessionModel from "../../api/models/SessionModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import moment from "moment";
import { isValidMoment } from "../../helpers/date_helpers";
type SessionsInProgressCardPropsTypes = {
  session: SessionModel;
};
export default function SessionsInProgressCard(
  props: SessionsInProgressCardPropsTypes
) {
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { session } = props;

  return (
    <div className="bg-white flex gap-8   flex-col  md:flex-row md:items-center justify-between shadow-sm border border-gray-100 rounded-lg w-full p-4 ">
      <div>
        <h2 className="text-gray-800 text-base font-medium">
          {" "}
          {t("sessionNumber", { session: "#" + session?.sessionNumber })}
        </h2>
      </div>
      <div className="flex gap-3 pe-4">
        <UserProfilePictureAvatar
          profilePictureUrl={session?.student?.profile_picture_url}
          className="w-10 h-10"
          alt="sand-user-img"
        />
        <div className="flex items-start gap-1 flex-col">
          <div className="w-full flex gap-2 items-center">
            <h3 className="text-base leading-[27px] truncate md:w-32 font-semibold text-gray-800">
              {session?.student?.full_name ??
                `${session?.student?.firstName} ${session?.student?.lastName}`}
            </h3>
            <span className="bg-gray-100 rounded-[10px] py-0.5 px-2.5 ">
              {t("reader")}
            </span>
          </div>
          <p className="text-sm font-normal text-gray-500">
            {t("sessionStartTime", {
              time: isValidMoment(session.start_time)
                ? session.start_time?.format("hh:mm A")
                : "",
            })}
          </p>
        </div>
      </div>
      <div className="flex gap-3 pe-4">
        <UserProfilePictureAvatar
          profilePictureUrl={session?.tutor?.profile_picture_url}
          className="w-10 h-10"
          alt="sand-user-img"
        />
        <div className="flex items-start gap-1 flex-col">
          <div className="w-full flex gap-2 items-center">
            <h3 className="text-base truncate md:w-32 leading-[27px] font-semibold text-gray-800">
              {session?.tutor?.full_name ??
                `${session?.tutor?.firstName} ${session?.tutor?.lastName}`}
            </h3>
            <span className="bg-gray-100 rounded-[10px] py-0.5 px-2.5 ">
              {t("tutor")}
            </span>
          </div>
          <p className="text-sm font-normal text-gray-500">
            {t("sessionStartTime", {
              time: isValidMoment(session.start_time)
                ? session.start_time?.format("hh:mm A")
                : "",
            })}
          </p>
        </div>
      </div>
      <div className=" ">
        <div className="flex md:items-start gap-4 md:gap-1 flex-row md:flex-col items-center">
          <p className="text-xs font-normal text-gray-400">
            {t("sessionTime")}
          </p>
          <h3 className="text-2xl leading-[28px] font-semibold text-brandblue-600 ">
            {isValidMoment(session.start_time) &&
              session.start_time?.format("hh:mm")}
            <span className="text-xs font-normal">
              {isValidMoment(session.start_time) &&
                ` ${session.start_time?.format("A")}`}
            </span>
          </h3>
        </div>
      </div>
    </div>
  );
}
